import React from "react";
import { Dropdown, TextArea } from "colbi_web_ui/lib/components/inputs";
import { SovosIcon } from "mosaic-react";
import { HighlightOff } from "mosaic-react-icons";
import styles from "./ConfigMergeContainer.module.sass";

const ConfigContainer = ({ config, index, onChange, appliesToFilter }) => {
    const handleDescriptionChange = (e) => {
        const updatedConfig = { ...config, Description: e.target.value };
        onChange(index, updatedConfig);
    };

    const handleConfigurationChange = (e) => {
        const updatedConfig = { ...config, Configuration: e.target.value };
        onChange(index, updatedConfig);
    };

    const handleFileTypeChange = (e) => {
        const updatedConfig = { ...config, FileType: e.target.value.id };
        onChange(index, updatedConfig);
    };

    const handleRemoveClick = () => {
        onChange(index, null);
    };

    return (
        <div className={`${styles["rule-entry"]} ${styles["flex"]}`}>
            <div className={styles["input-field"]}>
                <div className={styles["locale-container"]}>
                    <Dropdown
                        placeholder={""}
                        className={styles["period-dropdown"]}
                        secondary
                        options={appliesToFilter}
                        value={config ? config.FileType : ""}
                        onChange={(e) => {
                            handleFileTypeChange(e);
                        }}
                    />
                    <div className={styles["remove-button-container"]}>
                        <button
                            type="button"
                            className={styles["remove-button"]}
                            onClick={handleRemoveClick}
                        >
                            <SovosIcon>
                                <HighlightOff />
                            </SovosIcon>
                        </button>
                    </div>
                </div>
                <div>
                    <TextArea
                        className={styles["login-text-input"]}
                        type="text"
                        autoComplete="off"
                        autoCorrect="off"
                        spellCheck="false"
                        name={`Title`}
                        placeholder={`Enter a Description`}
                        value={config ? config.Description : ""}
                        onChange={handleDescriptionChange}
                    />
                    <TextArea
                        className={styles["login-text-input"]}
                        type="text"
                        autoComplete="off"
                        autoCorrect="off"
                        spellCheck="false"
                        name={`Configuration`}
                        placeholder={`Enter a Configuration`}
                        value={config ? config.Configuration : ""}
                        onChange={handleConfigurationChange}
                    />
                </div>
            </div>
        </div>
    );
};

export default ConfigContainer;
